import { NgkAuthConfig } from '@kin/ngk-auth';

import { AppApiRootList, AppEnvironment } from 'app/app-config/app-config.model';

/**
 * Keycloak authority (realm URL) per environment.
 */
export const keycloakAuthorityConfig: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'https://keycloak.kin.haus/realms/staging'],
  ['development', 'https://keycloak.kin.haus/realms/staging'],
  ['staging', 'https://keycloak.kin.haus/realms/staging'],
  ['production', 'https://keycloak.kin.insure/realms/production'],
]);

/**
 * Keycloak client ID per environment.
 */
export const keycloakClientIdConfig: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'local-quoting-ui'],
  ['development', 'staging-quoting-ui'],
  ['staging', 'staging-quoting-ui'],
  ['production', 'xYt9Hq2JkD67mOPaRe5WQ8R99'],
]);

/**
 * Customer Portal base URL per environment.
 * Used as the fallback redirect destination when a portal customer's session ends.
 */
export const customerPortalUrlConfig: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'http://localhost:3000/kin_portal'],
  ['development', 'https://app.kin.haus/kin_portal'],
  ['staging', 'https://app.kin.haus/kin_portal'],
  ['production', 'https://app.kin.com/kin_portal'],
]);

/**
 * Trusted origins for the `return_url` query parameter.
 * Only return URLs whose origin matches one of these will be accepted.
 */
export const TRUSTED_RETURN_ORIGINS: readonly string[] = ['http://localhost:3000', 'https://app.kin.haus', 'https://app.kin.com'];

/**
 * Builds the NgkAuthConfig for the given environment.
 * Derives interceptorRootUrls from the resolved API roots so that session storage overrides
 * (for ephemeral environments) are reflected in the NgkAuth token interceptor.
 */
export function buildAuthConfig(environment: AppEnvironment, apiRoot: AppApiRootList, origin: string): NgkAuthConfig {
  const authority = keycloakAuthorityConfig.get(environment)!;
  const clientId = keycloakClientIdConfig.get(environment)!;

  return {
    authority,
    clientId,
    redirectUrl: `${origin}/platform/login`,
    postLogoutRedirectUrl: `${origin}/platform/login?logged_out_by_inactivity=true`,
    interceptorRootUrls: [apiRoot.intake, apiRoot.opportunities],
  };
}
